import type { TFunction } from 'i18next'

/**
 * Labels for Sentry User Feedback (@sentry-internal/feedback). Must stay in sync
 * with the SDK's configurable options (see feedbackIntegration options).
 */
export function getSentryFeedbackIntegrationOptions(t: TFunction) {
	return {
		triggerLabel: t('sentryFeedback.triggerLabel'),
		formTitle: t('sentryFeedback.formTitle'),
		submitButtonLabel: t('sentryFeedback.submitButtonLabel'),
		cancelButtonLabel: t('sentryFeedback.cancelButtonLabel'),
		confirmButtonLabel: t('sentryFeedback.confirmButtonLabel'),
		emailLabel: t('sentryFeedback.emailLabel'),
		messageLabel: t('sentryFeedback.messageLabel'),
		nameLabel: t('sentryFeedback.nameLabel'),
		isRequiredLabel: t('sentryFeedback.isRequiredLabel'),
		addScreenshotButtonLabel: t('sentryFeedback.addScreenshotButtonLabel'),
		removeScreenshotButtonLabel: t('sentryFeedback.removeScreenshotButtonLabel'),
		emailPlaceholder: t('sentryFeedback.emailPlaceholder'),
		messagePlaceholder: t('sentryFeedback.messagePlaceholder'),
		namePlaceholder: t('sentryFeedback.namePlaceholder'),
		successMessageText: t('sentryFeedback.successMessageText'),
	}
}
